import { Component } from '@angular/core';
import { commonImports } from '../../../common';

@Component({
    selector: 'app-load-overlay-component',
    imports: [...commonImports],
    templateUrl: './load-overlay-component.component.html',
    styleUrl: './load-overlay-component.component.scss'
})
export class LoadOverlayComponentComponent {}
